// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"bc7a0a71","990":"92f1e9e2"}[chunkId] + ".chunk.js";
};